import { authHeader } from "../../../helpers/authHeader";
import { handleResponse } from "../../../helpers/handleresponse";

export const templateService = {
  get,
  update,
  create,
  getAllByEvent,
  getDefaultByEvent,
  checkForUpdates,
};


async function create(templateDto) {
  const requestOptions = {
    method: "POST",
    headers: authHeader({ "Content-Type": "application/json" }),
    body: JSON.stringify(templateDto)

  };

  return fetch(`./api/template/`, requestOptions)
    .then(handleResponse)
    .then(template => {
      return template;
    });
}

async function get(templateId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader({})
  };

  return fetch(`./api/template/${templateId}`, requestOptions)
    .then(handleResponse)
    .then(template => {
      return template;
    });
}

async function checkForUpdates(templateId, lastModified) {
  const requestOptions = {
    method: "GET",
    headers: authHeader({ "Content-Type": "application/json" }),

  };

  return fetch(`./api/template/checkforupdates/${templateId}?lastModified=${lastModified}`, requestOptions)
    .then(handleResponse)
    .then(isModified => {
      return isModified;
    });
}


async function getDefaultByEvent(eventId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader({})
  };

  return fetch(`./api/template/eventdefault/${eventId}`, requestOptions)
    .then(handleResponse)
    .then(template => {
      return template;
    });
}



async function getAllByEvent(eventId, includeInherited) {
  const requestOptions = {
    method: "GET",
    headers: authHeader({})
  };

  return fetch(`./api/template/event/${eventId}?includeInherited=${includeInherited}`, requestOptions)
    .then(handleResponse)
    .then(template => {
      return template;
    });
}

async function update(template) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader({ "Content-Type": "application/json" }),
    body: JSON.stringify(template)
  };
  return fetch(`./api/template/`, requestOptions)
    .then(handleResponse);
}

